import { Component } from '@theme/component';
import { isClickedOutside } from '@theme/utilities';

/**
 * Closes the store location dropdown when clicking outside the control.
 *
 * @extends {Component}
 */
class StoreLocationSelectComponent extends Component {
  #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('click', this.#handleClickOutside, {
      signal: this.#controller.signal,
      capture: true,
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
    super.disconnectedCallback();
  }

  /**
   * @param {PointerEvent} event
   */
  #handleClickOutside = (event) => {
    const details = this.querySelector('details');

    if (!(details instanceof HTMLDetailsElement) || !details.open) return;
    if (!isClickedOutside(event, this)) return;

    details.open = false;
  };
}

if (!customElements.get('store-location-select')) {
  customElements.define('store-location-select', StoreLocationSelectComponent);
}
